// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__3M_BI","content":"SubHeader_content__158IG","btnBack":"SubHeader_btnBack__DAA2V","line":"SubHeader_line__2DKdP"};